export const styles = (theme) => {
    return {
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: "#fff",
        },
        summary: {
            [theme.breakpoints.down("md")]: {
                paddingLeft:"10px !important",
                paddingRight:"10px !important"
            }
        }
    };
};